import { createContext } from "react";

import type useTrialInstitutionSupportingSiteIdentityById from "src/hooks/data/load/useTrialInstitutionSupportingSiteIdentityById";

/**
 * Describes the supporting site identity loader state and its refresh/cache actions.
 */
export interface ITrialInstitutionSupportingSiteIdentityContext extends ReturnType<
    typeof useTrialInstitutionSupportingSiteIdentityById
> {}

/**
 * Shares supporting site identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const TrialInstitutionSupportingSiteIdentityContext =
    createContext<ITrialInstitutionSupportingSiteIdentityContext>({
        data: undefined,
        error: undefined,
        loading: false,
        validating: false,
        mutate: async () => undefined,
        refresh: async () => undefined
    });

export default TrialInstitutionSupportingSiteIdentityContext;
